<template>
<b-row>
    <b-col v-for="item in items" :key = item.id>
        <app-card :item= "item" >
        </app-card>
    </b-col>
</b-row>
</template>

<script>
import AppCard from '../components/AppCardMuzObor'
export default {
    props:['items'],
    components:{AppCard}

}
</script>

<style scoped>
.row {
    justify-content: center;
    padding-right: 20px;
    padding-left: 20px;
    margin-bottom: 20px;
}

.col {
    border: 1px solid black;
    border-radius: 5px;
    margin: 10px;
    padding: 5px;
    text-align: center;
    display: flex;
    justify-content: space-between;
    max-width: 250px;
    min-width: 225px;
}


</style>
